// extracted by mini-css-extract-plugin
export default {"menu":"consignee-catalog_menu__hPAjV","searchWrap":"consignee-catalog_searchWrap__mlTVJ","searchLabel":"consignee-catalog_searchLabel__UeMme"};